import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum SystemParameterReduxTypes {
  FETCH_SYSTEM_PARAMETERS = "@@systemParameter/FETCH_SYSTEM_PARAMETERS",
  FETCH_SYSTEM_PARAMETERS_SUCCESS = "@@systemParameter/FETCH_SYSTEM_PARAMETERS_SUCCESS",
  FETCH_SYSTEM_PARAMETERS_ERROR = "@@systemParameter/FETCH_SYSTEM_PARAMETERS_ERROR",

  FETCH_SYSTEM_PARAMETER_BY_ID = "@@systemParameter/FETCH_SYSTEM_PARAMETER_BY_ID",
  FETCH_SYSTEM_PARAMETER_BY_ID_SUCCESS = "@@systemParameter/FETCH_SYSTEM_PARAMETER_BY_ID_SUCCESS",
  FETCH_SYSTEM_PARAMETER_BY_ID_ERROR = "@@systemParameter/FETCH_SYSTEM_PARAMETER_BY_ID_ERROR",

  UPDATE_SYSTEM_PARAMETER = "@@systemParameter/UPDATE_SYSTEM_PARAMETER",
  UPDATE_SYSTEM_PARAMETER_SUCCESS = "@@systemParameter/UPDATE_SYSTEM_PARAMETER_SUCCESS",
  UPDATE_SYSTEM_PARAMETER_ERROR = "@@systemParameter/UPDATE_SYSTEM_PARAMETER_ERROR",

  FETCH_SYSTEM_PARAMETER_VERSION = "@@systemParameter/FETCH_SYSTEM_PARAMETER_VERSION",
  FETCH_SYSTEM_PARAMETER_VERSION_SUCCESS = "@@systemParameter/FETCH_SYSTEM_PARAMETER_VERSION_SUCCESS",
  FETCH_SYSTEM_PARAMETER_VERSION_ERROR = "@@systemParameter/FETCH_SYSTEM_PARAMETER_VERSION_ERROR",

  FETCH_SYSTEM_PARAMETER_VERSION_DETAILS = "@@systemParameter/FETCH_SYSTEM_PARAMETER_VERSION_DETAILS",
  FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_SUCCESS = "@@systemParameter/FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_SUCCESS",
  FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_ERROR = "@@systemParameter/FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_ERROR",

  FETCH_SYSTEM_PARAMETER_LATEST_VERSION = "@@systemParameter/FETCH_SYSTEM_PARAMETER_LATEST_VERSION",
  FETCH_SYSTEM_PARAMETER_LATEST_VERSION_SUCCESS = "@@systemParameter/FETCH_SYSTEM_PARAMETER_LATEST_VERSION_SUCCESS",
  FETCH_SYSTEM_PARAMETER_LATEST_VERSION_ERROR = "@@systemParameter/FETCH_SYSTEM_PARAMETER_LATEST_VERSION_ERROR",

  APPROVE_SYSTEM_PARAMETER = "@@systemParameter/APPROVE_SYSTEM_PARAMETER",
  APPROVE_SYSTEM_PARAMETER_SUCCESS = "@@systemParameter/APPROVE_SYSTEM_PARAMETER_SUCCESS",
  APPROVE_SYSTEM_PARAMETER_ERROR = "@@systemParameter/APPROVE_SYSTEM_PARAMETER_ERROR",

  REJECT_SYSTEM_PARAMETER = "@@systemParameter/REJECT_SYSTEM_PARAMETER",
  REJECT_SYSTEM_PARAMETER_SUCCESS = "@@systemParameter/REJECT_SYSTEM_PARAMETER_SUCCESS",
  REJECT_SYSTEM_PARAMETER_ERROR = "@@systemParameter/REJECT_SYSTEM_PARAMETER_ERROR",

  PUBLISH_SYSTEM_PARAMETER = "@@systemParameter/PUBLISH_SYSTEM_PARAMETER",
  PUBLISH_SYSTEM_PARAMETER_SUCCESS = "@@systemParameter/PUBLISH_SYSTEM_PARAMETER_SUCCESS",
  PUBLISH_SYSTEM_PARAMETER_ERROR = "@@systemParameter/PUBLISH_SYSTEM_PARAMETER_ERROR",

  RESET = "@@systemParameter/RESET",

  SET_SYSTEM_PARAMETER_LIST_UI = "@@systemParameter/SET_LIST_UI",
  RESET_SYSTEM_PARAMETER_LIST_UI = "@@systemParameter/RESET_LIST_UI"
}

export type SystemParameterListUiState = {
  currentPage: number;
  searchFilter: Record<string, any>;
  sort: { field: string; order: boolean };
  isFilterApplied: boolean;
};


export type SystemParameterActionDispatch = {
  type:
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID
    | SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION
    | SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.PUBLISH_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.RESET;
  payload: any;
};

export type SystemParameterReducerDispatch = {
  type:
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS_SUCCESS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS_ERROR
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID_SUCCESS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID_ERROR
    | SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER_SUCCESS
    | SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER_ERROR
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_SUCCESS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_ERROR
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_SUCCESS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_ERROR
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION_SUCCESS
    | SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION_ERROR
    | SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER_SUCCESS
    | SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER_ERROR
    | SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER_SUCCESS
    | SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER_ERROR
    | SystemParameterReduxTypes.PUBLISH_SYSTEM_PARAMETER
    | SystemParameterReduxTypes.PUBLISH_SYSTEM_PARAMETER_SUCCESS
    | SystemParameterReduxTypes.PUBLISH_SYSTEM_PARAMETER_ERROR
    | SystemParameterReduxTypes.RESET;
  payload: {
    data?: FetchApiResponse<SystemParameter>;
    error?: string;
  };
};

export type SystemParameterReduxState = {
  loading?: boolean;
  data?: FetchApiResponse<SystemParameter>;
  error?: string | null;
};

export type SystemParameter = {
  id: string;
  externalId: string;
  npaDpd: number;
  status: string;
  draft: boolean;
  makerRemarks: string;
  checkerRemarks: string;
  createdOn: Date;
  updatedOn: Date;
  actionByUserRecord?: { name: string };
};

export type UpdateSystemParameter = {
  externalId: string;
  npaDpd: number;
  makerRemarks: string;
  draft: boolean;
};

export type SystemParameterCreateReduxState = {
  loading?: boolean;
  data?: CreateApiResponse<SystemParameter>;
  error?: string | null;
};

export type SystemParameterFetchRequest = {
  payload: FilterMetadata;
  type: string;
};

export type SystemParameterUpdateRequest = {
  payload: UpdateSystemParameter;
  type: string;
};

export type FetchSystemParameterByIdRequest = {
  payload: string;
  type: string;
};
